// extracted by mini-css-extract-plugin
export default {"back__btn":"FunctionsADMIN_back__btn__H7ZIP","center__btn":"FunctionsADMIN_center__btn__3SrG9"};